import styled from 'styled-components';

export const Form = styled.form`
  width: 92%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-bottom: 0;

  h3 {
    font-size: ${16 / 16}rem;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: ${props => props.theme.palette.greyscale.grey900};
    word-break: break-word;
    text-align: center;
  }

  > p {
    font-size: ${13 / 16}rem;
    color: ${props => props.theme.palette.greyscale.grey500};
    margin: 0 0 18px 0;
    line-height: 1.5;
    word-break: break-word;
    text-align: center;
    max-width: 100%;
  }

  @media(max-width: ${props => props.theme.breakpoints.mobileSm}){
    width: 85%;

    h3 {
      font-size: ${14 / 16}rem;
      font-weight: 700;
      margin: 0 0 6px 0;
    }

    > p {
      font-size: ${12 / 16}rem;
      margin: 0 0 14px 0;
      line-height: 1.4;
    }
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    h3 {
      font-size: ${18 / 16}rem;
      margin: 0 0 10px 0;
    }

    > p {
      font-size: ${14 / 16}rem;
      margin: 0 0 20px 0;
      line-height: 1.6;
    }
  }
`;

export const OtpContainer = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
  width: 100%;
  margin: 12px 0 16px;

  @media(max-width: ${props => props.theme.breakpoints.mobileSm}){
    gap: 5px;
    margin: 10px 0 14px;
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    gap: 8px;
    margin: 14px 0 20px;
  }
`;

export const OtpInput = styled.input`
  width: 40px;
  height: 40px;

  border: 1px solid ${props => props.theme.palette.greyscale.grey200};
  border-radius: 4px;

  font-size: ${18 / 16}rem;
  font-weight: 600;
  text-align: center;

  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.palette.primary.blue500};
    box-shadow: 0 0 0 2px rgba(110, 165, 255, 0.1);
  }

  &:disabled {
    background-color: ${props => props.theme.palette.greyscale.grey50};
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media(max-width: ${props => props.theme.breakpoints.mobileSm}){
    width: 36px;
    height: 36px;
    font-size: ${16 / 16}rem;
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    width: 44px;
    height: 44px;
    font-size: ${20 / 16}rem;
  }
`;

export const Button = styled.button`
  width: 100%;

  padding: 9px 24px;

  background: ${props => props.theme.palette.primary.blue500};

  border: 0;

  font-size: 14px;
  font-weight: 600;
  color: #FFF;

  cursor: pointer;

  transition: background-color 0.3s ease;

  &:hover:not(:disabled) {
    background-color: ${props => props.theme.palette.primary.blue600};
  }

  &:disabled {
    background-color: ${props => props.theme.palette.greyscale.grey300};
    cursor: not-allowed;
    opacity: 0.7;
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}){
    padding: 10px 24px;
    font-size: 12px;
  }

  @media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
    padding: 10px 24px;
    font-size: 15px;
  }
`;

export const ErrorText = styled.p`
  color: #FF3838; 
  font-size: 12px;
  margin: 0 0 12px 0;
  line-height: 1.4;
  width: 100%;

  @media(max-width: ${props => props.theme.breakpoints.tablet}){
    font-size: 11px;
    margin: 0 0 10px 0;
  }
`;

export const ResendContainer = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${props => props.theme.palette.greyscale.grey500};
  margin: 10px 0 12px;
  width: 100%;

  @media(max-width: ${props => props.theme.breakpoints.mobileSm}){
    font-size: 11px;
    margin: 8px 0 10px;
  }

  @media(min-width: ${props => props.theme.breakpoints.desktopXl}){
    font-size: 13px;
    margin: 12px 0 14px;
  }

  button {
    background: none;
    border: none;
    color: ${props => props.theme.palette.primary.blue500};
    cursor: pointer;
    text-decoration: underline;
    font-size: inherit;
    font-weight: 500;
    padding: 0;
    transition: color 0.3s ease;

    &:hover:not(:disabled) {
      color: ${props => props.theme.palette.primary.blue600};
    }

    &:disabled {
      color: ${props => props.theme.palette.greyscale.grey300};
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
`;

export const Timer = styled.p`
  margin: 0;
  color: ${props => props.theme.palette.secondary.orange500};
  font-weight: 600;
  font-size: 12px;

  @media(max-width: ${props => props.theme.breakpoints.mobileSm}){
    font-size: 11px;
  }

  @media(min-width: ${props => props.theme.breakpoints.desktopXl}){
    font-size: 13px;
  }
`;